import { render, staticRenderFns } from "./HelpfulInfoArticle3.vue?vue&type=template&id=4944e0e0&scoped=true"
import script from "./HelpfulInfoArticle3.vue?vue&type=script&lang=js"
export * from "./HelpfulInfoArticle3.vue?vue&type=script&lang=js"
import style0 from "./HelpfulInfoArticle3.vue?vue&type=style&index=0&id=4944e0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944e0e0",
  null
  
)

export default component.exports